import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { ArrowLeftIcon, Pane, Button } from 'evergreen-ui';

import { Layout, Link, AffiliateDisclosure } from '../components/common'
import { MetaData } from '../components/common/meta'
import { currentMonth, currentYear } from '../utils/constants'

/**
* Single post view (/:slug)
*
* This file renders a single post and loads all the content.
*
*/
const ReferralCodePage = ({ data, location }) => {
    const page = data.ghostPage
    
    const updatedData = {
        ...data,
        ghostPage: {
            ...page,
            custom_excerpt: page.custom_excerpt ? page.custom_excerpt.replace(/July/g, currentMonth).replace(/2025/g, currentYear) : page.custom_excerpt,
            excerpt: page.excerpt ? page.excerpt.replace(/July/g, currentMonth).replace(/2025/g, currentYear) : page.excerpt,
            html: page.html ? page.html.replace(/July/g, currentMonth).replace(/2025/g, currentYear) : page.html,
            plaintext: page.plaintext ? page.plaintext.replace(/July/g, currentMonth).replace(/2025/g, currentYear) : page.plaintext
        }
    }

    const updatedPage = updatedData.ghostPage
    
    return (
        <>
            <MetaData
                data={updatedData}
                location={location}
                type="article"
            />
            <Helmet>
                <style type="text/css">{`${updatedPage.codeinjection_styles}`}</style>
            </Helmet>
            <Layout location={location}>
                <div className="container referral-info">
                    <article className="content">
                        <section className="post-full-content">
                            {/* <Link to="/referrals/">
                                <Button iconBefore={ArrowLeftIcon} appearance="minimal" size="large" intent="info" color="#26a8ed">
                                    All Sign Up Bonuses
                                </Button>
                            </Link> */}
                            <Link to="/referrals/"><ArrowLeftIcon marginBottom={4} /> All Referral Codes</Link>
                        </section>
                        { updatedPage.feature_image ?
                            <figure className="post-feature-image">
                                <img width="2" height="1" src={ updatedPage.feature_image } alt={`${updatedPage.title} Logo`} />
                            </figure> : null }
                        <section className="post-full-content">
                            <h1 className="content-title">{updatedPage.title}</h1>

                            {/* The main page content */ }
                            <section
                                className="content-body load-external-scripts"
                                dangerouslySetInnerHTML={{ __html: updatedPage.html }}
                            />
                            <Pane className="post-full-content" textAlign="center">
                                <hr/>
                                <Link to="/referrals/" style={{ textDecoration: 'none' }}>
                                    <Button marginRight={12} marginBottom={12} size="large" appearance="primary">
                                        More Referral Codes / Sign Up Bonuses
                                    </Button>
                                </Link>
                                <Link to="/bitcoin-btc-interest/" style={{ textDecoration: 'none' }}>
                                    <Button marginRight={12} marginBottom={12} size="large" >
                                        Compare Best Rates by Cryptocurrency
                                    </Button>
                                </Link>
                            </Pane>
                            <AffiliateDisclosure large />
                        </section>
                    </article>
                </div>
            </Layout>
        </>
    )
}

export default ReferralCodePage

export const postQuery = graphql`
    query($slug: String!) {
        ghostPage(slug: { eq: $slug }) {
            ...GhostPageFields
        }
    }
`
